import {PricingItem} from "./pricing-item";
import {Option} from "../option";

export class OptionPricingItem extends PricingItem {
    public option?: Option;
}
